import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { List } from 'antd';
import {
	FolderOutlined,
	FileImageOutlined,
	FileOutlined,
	FileFilled,
	VideoCameraOutlined,
} from '@ant-design/icons';
import ProgressiveImage from 'components/ProgressiveImage';
import { getSourcesForVideo, getSourcesForPdf } from '../ProgressiveImage/imageHelpers';
import { sortMedia } from 'utils';
import './MediaWrapper.scss';

export default class RenderMediaItem extends Component {
	renderMediaItem = (mediaItem, i) => {
		const { event, listType, linkType, library, libraryType, handlePickItem } = this.props;
		const type = !libraryType ? mediaItem.mime_type.split('/')[0] : null;
		const secondaryType = type && mediaItem.mime_type.split('/')[1];
		const iconType = libraryType ? (
			<FolderOutlined />
		) : type === 'image' ? (
			<FileImageOutlined />
		) : type === 'video' ? (
			<VideoCameraOutlined />
		) : (
			<FileOutlined />
		);

		const link =
			linkType === 'eventMedia'
				? `/events/${event.id}/media/${mediaItem.id}`
				: 'eventLibrary'
				? `/events/${event.id}/library/${mediaItem.id}`
				: '';

		const ConditionalLink = ({ children, link, handlePickItem }) =>
			!handlePickItem && link ? (
				<Link
					to={{
						pathname: link,
						query: { library: library ? library : null },
					}}
					key={`mediaItem-${i}`}
					state={{ library }}
				>
					{children}
				</Link>
			) : (
				<div key={`mediaItem-${i}`}>{children}</div>
			);

		const sources =
			type === 'video'
				? getSourcesForVideo(mediaItem.src)
				: type === 'application'
				? getSourcesForPdf(mediaItem.src)
				: {};
		const allowThumb = type !== 'application' || secondaryType === 'pdf';
		const thumb = sources && sources.thumbnail && allowThumb && (
			<img src={sources.thumbnail} alt={mediaItem.name} />
		);

		const children = (
			<div
				className={listType === 'thumbnail' ? 'mediaItemThumbnailContainer' : 'mediaItemContainer'}
				onClick={handlePickItem ? handlePickItem(mediaItem) : null}
				style={{ cursor: handlePickItem ? 'pointer' : null }}
			>
				{!libraryType ? (
					<div
						className="mediaItemPreview"
						style={{ display: listType === 'list' ? 'none' : null }}
					>
						{thumb ? (
							thumb
						) : type === 'image' ? (
							<ProgressiveImage
								type={mediaItem.mime_type}
								src={mediaItem.src}
								alt={mediaItem.name}
							/>
						) : type === 'video' ? (
							<video controls={true} src={mediaItem.src} />
						) : type === 'audio' ? (
							<audio controls={true} src={mediaItem.src} title="mediaItem" />
						) : secondaryType === 'pdf' || secondaryType === 'html' ? (
							<iframe src={mediaItem.src} title="mediaItem" frameBorder="0" scrolling="no" />
						) : (
							<FileFilled style={{ fontSize: '32px', color: 'white' }} />
						)}
					</div>
				) : null}

				<div className="mediaItemLink">
					{iconType}
					<p>{mediaItem.name}</p>
				</div>
			</div>
		);

		return (
			<ConditionalLink
				handlePickItem={handlePickItem}
				children={children}
				link={link}
				key={`mediaItemWrapper-${i}`}
			/>
		);
	};

	render() {
		const { header, footer, media, listType, hideHeader, library } = this.props;
		const sortedMedia = library ? sortMedia(media, library.sort_order) : media;
		return (
			<List
				className="renderMediaList"
				bordered
				header={hideHeader ? null : <div className="mediaLibraryListHeader">{header}</div>}
				rowKey="id"
				footer={footer ? footer : null}
			>
				<div className={listType === 'thumbnail' ? 'mediaThumbnailList' : null}>
					{sortedMedia.map((mediaItem, i) => this.renderMediaItem(mediaItem, i))}
				</div>
			</List>
		);
	}
}
